<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2229_6277)">
<rect x="1.3" y="0.8" width="35.4" height="28.4" rx="1.2" stroke="currentColor" stroke-width="1.6"/>
<rect x="5.5" y="4" width="2" height="2" rx="1" fill="currentColor"/>
<rect x="9.5" y="4" width="2" height="2" rx="1" fill="currentColor"/>
<rect x="13.5" y="4" width="2" height="2" rx="1" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2229_6277">
<rect width="38" height="30" rx="3" fill="white"/>
</clipPath>
</defs>
</svg>
